import { Dispatch } from "redux";
import { ApiConfig, createRequestActionTypes, createRequestThunk, FetchRequestActions, RequestThunkParameters } from "../../../..";
import { AppStateWithData } from "../../..";
import { FeedItem } from "../../../../models/Feed";
import { processFeedResponse } from "./processFeedResponse";

export const loadMoreFeedItemsActionTypes = createRequestActionTypes('LOAD_MORE_FEED_ITEMS')

export type LoadMoreFeedItemsAction = FetchRequestActions<FeedItem[], LoadMoreFeedItemsAdditionalData>

export interface LoadMoreFeedItemsAdditionalData {
    page: number
}

export const loadMoreFeedItems = (config: ApiConfig) => (page: number) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<FeedItem[], never, LoadMoreFeedItemsAdditionalData> = {
        method: 'GET',
        requestActionTypes: loadMoreFeedItemsActionTypes,
        url: `${config.API_URL}/feed?page=${page}`,
        actionAdditionalData: {
            page
        },
        processResultBeforeDispatch: processFeedResponse(dispatch)
    }
    return createRequestThunk(thunkParams)(dispatch, getState)
}